import { render } from "./PerformPage.vue?vue&type=template&id=3d3543bd"
import script from "./PerformPage.vue?vue&type=script&lang=js"
export * from "./PerformPage.vue?vue&type=script&lang=js"

import "./PerformPage.vue?vue&type=style&index=0&id=3d3543bd&lang=css"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__